import { createIcon } from '@chakra-ui/react';

export const RefundBoldIcon = createIcon({
  displayName: 'RefundBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M6.33301 9.6667C6.33301 10.3134 6.83302 10.8334 7.44635 10.8334H8.69967C9.233 10.8334 9.66634 10.38 9.66634 9.81336C9.66634 9.2067 9.39968 8.9867 9.00635 8.8467L6.99967 8.1467C6.60634 8.0067 6.33968 7.79337 6.33968 7.18003C6.33968 6.62003 6.773 6.16003 7.30634 6.16003H8.55967C9.17301 6.16003 9.67301 6.68003 9.67301 7.3267"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 5.5V11.5" stroke="#6E6789" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M14.6663 8.49998C14.6663 12.18 11.6797 15.1666 7.99967 15.1666C4.31967 15.1666 1.33301 12.18 1.33301 8.49998C1.33301 4.81998 4.31967 1.83331 7.99967 1.83331"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 2.5V5.16667H13.9997"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6663 1.83331L11.333 5.16665"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
